document.addEventListener('DOMContentLoaded', () => {
	const headers = document.querySelectorAll('.tbr-toggle .header');

	headers.forEach((block) => {
		block.addEventListener('click', () => {
			block.parentElement.classList.toggle('open');
		});
	});
});
